import { useNavigate } from 'react-router-dom';

export function Hijacking() {
  const navigate = useNavigate();

  // Array of platform data
  const platforms = [
    { name: 'Youtube Playlists', path: '/Cyber_Hijacking_Yt', logo: 'https://thumbs.dreamstime.com/b/high-resolution-colored-youtube-logo-white-background-vector-eps-file-available-additional-download-colored-youtube-logo-175730434.jpg' },
    { name: 'Coursera', path: '/Cyber_Hijacking_Coursera', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmVgLGfhr0DKM1D4bBSvZh9h6UdIG84qhbSsHAsn_P1KeOEa_wGqqbO9z1zcyn3atADVU&usqp=CAU' },
    { name: 'Udemy Courses', path: '/Cyber_Hijacking_Udemy', logo: 'https://logowik.com/content/uploads/images/udemy-new-20212512.jpg' },
    { name: 'PDF', path: '/Cyber_Hijacking_Pdf', logo: 'https://miro.medium.com/v2/resize:fit:799/0*yxCtOgS-v50Sqfzw.jpeg' },
  ];

  return (
    <div>
      <h1>Links are below</h1>
      <p>
        These are the platforms for your <strong>Session & Hijacking</strong> study purposes. Explore these recommended platforms to enhance your knowledge.
      </p>

      <h3>Recommended Platforms</h3>

      {/* Render each platform dynamically */}
      {platforms.map(({ name, path, logo }) => (
        <div className="container_html_pg" key={path}>
          <img className="html_logo_yt" style={{ height: '90px', width: '90px' }} src={logo} alt={`${name} logo`} />
          <h5 style={{ margin: '30px 0px 0px 30px', fontFamily: 'Arial', fontWeight: 'bold' }}>{name} &#9754;</h5>
          <div className="butt_yt">
            <button className="btn_html_yt" onClick={() => navigate(path)}>Click Me</button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Hijacking;
